import React, { useState } from 'react';
import { TextField, Button, Card, CardContent, Typography, Alert, CircularProgress } from '@mui/material';
import { Box } from '@mui/system';
import Center from './Center';
import useForm from '../hooks/useForm';
//import { variables } from './Variables.js';
import { createAPIEndpoint, ENDPOINTS } from '../api/index';
//import useStateContext from '../hooks/useStateContext';
import { useNavigate } from "react-router-dom";

const getFreshModel = () => ({
    name: '',
    email: '',
    password: ''
})


export default function Login() {
    //static displayName = Home.name;
    //const [context, setContext] = useStateContext();

    const navigate = useNavigate()
    const [showAlert, setShowAlert] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const { values,
        setValues,
        errors,
        setErrors,
        handleInputChange } = useForm(getFreshModel);

    const login = e => {
        e.preventDefault();
        if (validate()) {
            //console.log(values)
            setShowProgress(true);
            createAPIEndpoint(ENDPOINTS.participant)
                .post(values)
                .then(res => {
                    //console.log("context", res.data);
                    navigate("/quiz", { state: { values: values, participantid: res.data.participantId } })
                })
                .catch(err => {
                    //console.log(err);
                    setShowProgress(false);
                    setShowAlert(true)
                    setTimeout(() => {
                        setShowAlert(false)
                    }, 4000)
                })
        }

    };

    //console.log(values);

    const validate = () => {
        let temp = {};
        temp.email = (/\S+@\S+\.\S+/).test(values.email) ? "" : "Email is not valid!";
        //temp.password = (/^\d{3}-\d{3}-\d{4}$/).test(values.password) ? "" : "Phone number is not valid!";
        temp.name = values.name !== "" ? "" : "This field is required!";
        //console.log(values.password.length);
        temp.password = values.password.length === 10 ? "" : "Phone number length must be 10 digits."
        setErrors(temp);
        return Object.values(temp).every(x => x === "")
    }


    //render () {
    return (
        <Center>
            {/*{context.participantId}*/}
            <Card sx={{ width: 350, mt:1, mb:1 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="h3" sx={{ my: 3 }}>Competency Test</Typography>
                    <Box sx={{
                        '& .MuiTextField-root': {
                            m: 1,
                            width: '90%'
                        }
                    }}>
                        <form noValidate autoComplete='on' onSubmit={login}>
                            <TextField
                                label="Name"
                                name="name"
                                value={values.name}
                                onChange={handleInputChange}
                                variant="outlined"
                                {...(errors.name && { error: true, helperText: errors.name })}
                            />
                            <TextField
                                label="Email"
                                name="email"
                                value={values.email}
                                onChange={handleInputChange}
                                variant="outlined"
                                {...(errors.email && { error: true, helperText: errors.email })}
                            />
                            <TextField
                                type="tel"
                                label="Telephone"
                                name="password"
                                value={values.password}
                                onChange={handleInputChange}
                                variant="filled"
                                {...(errors.password && { error: true, helperText: errors.password })}
                            />
                            <Button type="submit"
                                variant="contained"
                                size="large"
                                sx={{ width: '90%' }}>Start</Button>
                            <Alert
                                severity="error"
                                variant="string"
                                sx={{
                                    width: '60%',
                                    m: 'auto',
                                    visibility: showAlert ? 'visible' : 'hidden'
                                }}
                            >
                                User Not Found! Verify your info and try again.
                            </Alert>
                            <Box sx={{
                                display: 'flex',
                                visibility: showProgress ? 'visible' : 'hidden'
                            }}>
                                <CircularProgress />
                            </Box>
                        </form>
                    </Box>
                </CardContent>
            </Card>
        </Center>
    );

    //}
}
